import joi from 'joi';
import { SearchElementType } from '@qualifio/data-search-api-client';
import { PromocodeImportAttributes } from '.';
import { PromocodeStatsAttributes } from './promocodes.types';

export enum RewardState {
  PENDING = 'PENDING',
  ACQUIRED = 'ACQUIRED',
  ARCHIVED = 'ARCHIVED',
}

export enum RewardType {
  PROMOCODE = 'PROMOCODE',
  CAMPAIGN_ACCESS = 'CAMPAIGN_ACCESS',
  CAMPAIGN_CODE = 'CAMPAIGN_CODE',
}

export enum RewardPeriod {
  MINUTE = 'MINUTE',
  HOUR = 'HOUR',
  DAY = 'DAY',
}

export interface ChannelInfo {
  type: SearchElementType.channel;
  uniqueId: string;
  campaignId: number;
}

export const $channelInfo = joi.object<ChannelInfo>({
  type: joi.string().valid(SearchElementType.channel),
  campaignId: joi.number(),
  uniqueId: joi.string(),
});

export interface CampaignAccessRewardData {
  channelInfoByLanguage?: { [language: string]: ChannelInfo };
  accessData: {
    nbParticipations: number;
    validityPeriod: {
      unit: RewardPeriod;
      value: number;
    };
  };
}

export interface CampaignCodeRewardData {
  campaignCodeData?: {
    codeListId: string;
  };
}

export interface RewardI18nAttributes {
  [language: string]: RewardI18nAttribute;
}

export interface RewardI18nAttribute {
  name: string;
  description?: string;
  image: string;
  details?: string;
  detailsLabel?: string;
}

interface BaseRewardAttributes {
  id: string;
  accountId: string;
  programId: string;
  i18nAttributes: RewardI18nAttributes;
  promocodeStats?: PromocodeStatsAttributes | null;
  promocodeImports?: PromocodeImportAttributes[];
  type: RewardType;
  createdAt?: string;
  updatedAt?: string;
  deletedAt?: string | null;
  clientIds?: number[]; //deprecated
  isNew?: boolean; // used only for backoffice frontend
}

export interface CampaignCodeReward extends BaseRewardAttributes {
  type: RewardType.CAMPAIGN_CODE;
  data: CampaignCodeRewardData;
}

export interface CampaignAccessReward extends BaseRewardAttributes {
  type: RewardType.CAMPAIGN_ACCESS;
  data: CampaignAccessRewardData;
}

export interface PromocodeReward extends BaseRewardAttributes {
  type: RewardType.PROMOCODE;
  data: undefined;
}

export type RewardAttributes = CampaignAccessReward | CampaignCodeReward | PromocodeReward;

export interface RewardsSettings {
  MAX_FILE_SIZE: number;
}

export const BURNABLE_REWARD_TYPES = [RewardType.CAMPAIGN_ACCESS, RewardType.PROMOCODE];
export type BurnableReward = RewardType.CAMPAIGN_ACCESS | RewardType.PROMOCODE;
